// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__2LoFK","info":"Note_info__3JYjI","note":"Note_note__1NRf2","actions":"Note_actions__1Alfy"};